import { makeStyles } from '@material-ui/styles'
import React, { useCallback } from 'react'
import Info from 'core/components/validatedForm/Info'
import TextField from 'core/components/validatedForm/TextField'
import ModalForm from 'core/elements/modal/ModalForm'
import Text from 'core/elements/Text'
import useParams from 'core/hooks/useParams'
import useUpdateAction from 'core/hooks/useUpdateAction'
import Theme from 'core/themes/model'
import { getCurrentUser } from 'openstack/helpers'
import { renameVirtualMachine } from './actions'
import { hasOtherUserVm } from './helpers'

export default function updateVirtualMachineDialog({ rows: vms, onClose }) {
  const vm = vms?.[0]
  const classes = useStyles()
  const defaultParams = {
    name: `${vm?.name}`,
  }
  const { params, getParamsUpdater } = useParams(defaultParams)

  const { update, updating, error } = useUpdateAction(renameVirtualMachine)
  const submitForm = useCallback(async () => {
    const { success } = await update({
      id: vm?.id,
      name: params.name,
      originalName: vm.name,
    })
    if (success) onClose(true)
  }, [vm, params])

  const { role: userRole, userId } = getCurrentUser()

  return (
    <ModalForm
      open
      panel="dialog"
      title={`Rename VM`}
      onSubmit={submitForm}
      onClose={onClose}
      submitting={updating}
      error={error}
      submitTitle={`Rename VM`}
    >
      <div className={classes.body}>
        {userRole === 'member' && hasOtherUserVm({ vms, userId }) && (
          <Info error>NOTE: You are performing an operation on another user's VM.</Info>
        )}
        <Text variant="body2">
          Rename VM <b>{vm?.name || vm?.id}</b>
        </Text>
        <TextField
          id="name"
          label="Name"
          onChange={getParamsUpdater('name')}
          value={params.name}
          info="This will also update the DNS name on all attached network ports. Any special characters and leading/trailing hyphens will be removed from the DNS name."
          required
        />
      </div>
    </ModalForm>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  body: {
    display: 'grid',
    gap: 12,
  },
}))
